import { CompletedIcon } from "@/designSystemIcons";

type Props = {
  completed: boolean;
  /**
   * Marks an unmet step as blocking rather than merely outstanding. A step the
   * user cannot clear from here (the browser they are on) reads as an error;
   * one they simply have not done yet stays neutral.
   */
  failed?: boolean;
};

export const CompletedStepIcon = ({ completed, failed }: Props) => {
  return completed ? (
    <div className="text-complete">
      <CompletedIcon width="16" height="16" />
    </div>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8.00098 6.87012L5.56641 4.43555L4.43555 5.56641L6.87012 8.00098L4.43555 10.4355L5.56641 11.5664L8.00098 9.13184L10.4355 11.5664L11.5664 10.4355L9.13184 8.00098L11.5664 5.56641L10.4355 4.43555L8.00098 6.87012Z"
        fill={failed ? "#F83959" : "#D4D8DE"}
      />
    </svg>
  );
};
